export const Timeline = ({
  text,
  top = '80px',
  bottom = '40px',
}: {
  text: string
  top?: string
  bottom?: string
}) => (
  <div className='d-flex flex-column justify-content-center align-items-center'>
    <LineTop height={top} />
    <div
      className='mc-px-2 mc-py-1 mc-corners--sm'
      style={{ border: '1px solid var(--mc-color-divider-strong)' }}
    >
      <p className='d-none d-md-block mc-text-h6'>{text}</p>
      <p className='d-block d-md-none mc-text-small'>{text}</p>
    </div>
    <LineBottom height={bottom} />
  </div>
)

export const LineTop = ({ height }: { height: string }) => (
  <div className='d-flex justify-content-center'>
    <div
      style={{
        width: '1px',
        height,
        background: 'linear-gradient(190deg, #3F3F43 0%,#9EA0A9 100%)',
      }}
    />
  </div>
)

export const LineBottom = ({ height }: { height: string }) => (
  <div className='d-flex justify-content-center'>
    <div
      style={{
        width: '1px',
        height,
        background: 'linear-gradient(180deg, #9EA0A9 0%,rgb(25, 24, 22) 100%)',
      }}
    />
  </div>
)
